module.exports = __webpack_public_path__ + "static/2-4386a3ad6aa5429d30dce0e3ac1baa4e.jpg";